<template>
  <div>
    <v-tabs v-model="tab" align-with-title class="ml-0">
      <v-tabs-slider
        :color="$vuetify.theme.currentTheme.primary"
      ></v-tabs-slider>

      <v-tab
        v-for="item in items"
        :key="item"
        class="ml-0"
        :color="$vuetify.theme.currentTheme.primary"
      >
        {{ item }}
      </v-tab>
    </v-tabs>
    <div>
      <v-tabs-items v-model="tab">
        <v-tab-item class="body treeview-body treeview-scroll">
          <div class="hierarchy-tree" v-if="userData.length">
            <HierarchyTree :data="userData" />
          </div>
          <NoData
            v-else
            title="Nothing to display"
            subTitle="Please create the hierarchy-tree for your organization"
          />
        </v-tab-item>
        <v-tab-item class="body treeview-body treeview-scroll">
          <v-container style="width: inherit; height: inherit">
            <div class="flex flex-wrap gap-4 p-4">
              <div
                v-for="(item, index) in nonReportee"
                :key="index"
                class="w-fit p-2 bg-white dark-bg-custom border-2 rounded-lg hover:bg-gray-50 hover:dark:bg-[#333333] transition-all duration-200"
              >
                <div class="flex justify-start items-center">
                  <v-icon color="#4b79a1" class="mr-2">
                    mdi-account-circle
                  </v-icon>
                  <v-list-item-title
                    class="text-start ml-2 font-medium text-gray-800 dark-text-color"
                  >
                    {{ item.fullName }}
                  </v-list-item-title>
                </div>
              </div>
            </div>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import HierarchyTree from "./HierarchyTree.vue";
import NoData from "@/components/NoData.vue";

export default {
  name: "TreeNode",
  components: {
    HierarchyTree,
    NoData,
  },
  data() {
    return {
      userData: [],
      nonReportee: [],
      tab: null,
      items: ["Hierarchy", "Non reportee"],
    };
  },
  mounted() {
    this.fetchEmployees();
  },
  methods: {
    async fetchEmployees() {
      try {
        const allUser = {
          limit: "*",
          // page: 1,
          sortBy: "firstName",
          sortOrder: "asc",
        };
        const response = await this.$axios.get("workforce/v2/users", {
          params: allUser,
        });
        if (response.data.success) {
          this.userData = this.structureData(response.data.users);
        }
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    },
    structureData(data) {
      const map = {};

      data.forEach((item) => {
        const id = item._id;
        if (!map[id]) {
          map[id] = { ...item, children: [] };
        }
      });

      const result = [];

      data.forEach((item) => {
        const id = item._id;
        const reportsToName = item.reportesTo?._id;

        if (reportsToName) {
          if (!map[reportsToName]) {
            map[reportsToName] = { id: reportsToName, children: [] };
          }
          map[reportsToName].children.push(map[id]);
        } else {
          if (map[id].children.length > 0 || item.reportesTo == null) {
            result.push(map[id]);
          } else {
            this.nonReportee.push(map[id]);
          }
        }
      });

      return result;
    },
  },
};
</script>

<style scoped>
.treeview-scroll::-webkit-scrollbar {
  width: 5px;
  height: 8px;
}

.treeview-scroll::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #e4e4e4;
}

.treeview-scroll::-webkit-scrollbar-thumb {
  background: #212121;
  border-radius: 10px;
  transition: 0.5s;
}

.treeview-scroll::-webkit-scrollbar-thumb:hover {
  background: #21427d;
  transition: 0.5s;
}

.treeview-body {
  white-space: nowrap;
  overflow-y: scroll;
  padding: 50px;
  max-height: 60vh;
  padding-top: 10px;
  text-align: center;
}

.hierarchy-tree {
  display: inline-block;
}
</style>
